import { render, staticRenderFns } from "./TestPackageEdit.vue?vue&type=template&id=47abe77b"
import script from "./TestPackageEdit.vue?vue&type=script&lang=js"
export * from "./TestPackageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports